import React, { useEffect, useState } from 'react';
import './FormData.scss';
import { countries, states } from '../../../constants/countries.constant';
import Customer from '../../../store/interfaces/customer.interface';
import useInput from '../../../components/hooks/use.input';
import { Button } from '../../../components/ui';

interface props {
  address?: string;
  data?: Customer;
  back?: () => void;
  changeStep: (number, Customer) => void;
}

const FormData: React.FC<props> = ({ address, data, changeStep, back }) => {
  const [country, setCountry] = useState<any>(null);
  const [countryStates, setCountryStates] = useState<any>([]);
  const [showForm, setShowForm] = useState(false);
  let formIsValid = false;

  const {
    value: firstName,
    isValid: enteredFirstNameIsValid,
    hasError: firstNameInputHasError,
    valueChangeHandler: firstNameChangedHandler,
    inputBlurHandler: firstNameBlurHandler,
    reset: resetFirstNameInput,
    error: firstNameError,
  } = useInput(value => {
    if (value.length === 0) {
      return { isValid: false, error: 'First name is Required' };
    } else if (value.length <= 1) {
      return { isValid: false, error: 'Minimum Character is 2' };
    } else {
      return { isValid: true, error: '' };
    }
  });

  const {
    value: lastName,
    isValid: enteredLastNameIsValid,
    hasError: lastNameInputHasError,
    valueChangeHandler: lastNameChangedHandler,
    inputBlurHandler: lastNameBlurHandler,
    reset: resetlastNameInput,
    error: lastNameError,
  } = useInput(value => {
    if (value.length === 0) {
      return { isValid: false, error: 'Last name is Required' };
    } else if (value.length <= 2) {
      return { isValid: false, error: 'Minimum Character is 2' };
    } else {
      return { isValid: true, error: '' };
    }
  });

  const {
    value: email,
    isValid: enteredEmailIsValid,
    hasError: emailInputHasError,
    valueChangeHandler: emailChangedHandler,
    inputBlurHandler: emailBlurHandler,
    reset: resetEmailInput,
    error: emailInputError,
  } = useInput(value => {
    if (value.length === 0) {
      return { isValid: false, error: 'Email is Required' };
    } else if (!value.includes('@')) {
      return { isValid: false, error: 'Email is invalid' };
    } else {
      return { isValid: true, error: '' };
    }
  });

  const {
    value: company,
    isValid: enteredCompanyIsValid,
    hasError: companyInputHasError,
    valueChangeHandler: companyChangedHandler,
    inputBlurHandler: companyBlurHandler,
    reset: resetCompanyInput,
  } = useInput(value => true);

  const {
    value: phoneNumber,
    isValid: enteredPhoneNumberIsValid,
    hasError: phoneNumberInputHasError,
    valueChangeHandler: phoneNumberChangedHandler,
    inputBlurHandler: phoneNumberBlurHandler,
    reset: resetPhoneNumberInput,
    error: phoneNumberInputError,
  } = useInput(value => {
    if (value.length === 0) {
      return { isValid: false, error: 'Phone number is Required' };
    } else if (value.length <= 2) {
      return { isValid: false, error: 'Minimum Character is 2' };
    } else {
      return { isValid: true, error: '' };
    }
  });

  const {
    value: faxNumber,
    isValid: enteredFaxNumberIsValid,
    hasError: faxNumberInputHasError,
    valueChangeHandler: faxNumberChangedHandler,
    inputBlurHandler: faxNumberBlurHandler,
    reset: resetFaxNumberInput,
  } = useInput(value => true);

  const {
    value: address1,
    isValid: enteredAddress1IsValid,
    hasError: address1InputHasError,
    valueChangeHandler: address1ChangedHandler,
    inputBlurHandler: address1BlurHandler,
    reset: resetAddress1Input,
    error: address1InputError,
  } = useInput(value => {
    if (value.length === 0) {
      return { isValid: false, error: 'Address is Required' };
    } else if (value.length <= 2) {
      return { isValid: false, error: 'Minimum Character is 2' };
    } else {
      return { isValid: true, error: '' };
    }
  });

  const {
    value: address2,
    isValid: enteredAddress2IsValid,
    hasError: address2InputHasError,
    valueChangeHandler: address2ChangedHandler,
    inputBlurHandler: address2BlurHandler,
    reset: resetAddress2Input,
  } = useInput(value => value.length >= 2);

  const {
    value: zip,
    isValid: enteredZipIsValid,
    hasError: zipInputHasError,
    valueChangeHandler: zipChangedHandler,
    inputBlurHandler: zipBlurHandler,
    reset: resetZipInput,
    error: zipInputError,
  } = useInput(value => {
    if (value.length === 0) {
      return { isValid: false, error: 'Zip Cpde is Required' };
    } else {
      return { isValid: true, error: '' };
    }
  });

  const {
    value: city,
    isValid: enteredCityIsValid,
    hasError: cityInputHasError,
    valueChangeHandler: cityChangedHandler,
    inputBlurHandler: cityBlurHandler,
    reset: resetCityInput,
    error: cityInputError,
  } = useInput(value => {
    if (value.length === 0) {
      return { isValid: false, error: 'Zip Code Required' };
    } else if (value.length <= 2) {
      return { isValid: false, error: 'Minimum Character is 2' };
    } else {
      return { isValid: true, error: '' };
    }
  });

  useEffect(() => {
    setCountryStates(countryStates);
  }, [countryStates]);

  useEffect(() => {
    if (data) setShowForm(true);
  }, [data]);

  const changeCountry = e => {
    setCountry(e.target.value);
    if (e.target.value === '1') {
      setCountryStates(states.filter(s => s.country == e.target.value));
    } else if (e.target.value == 0) {
      setCountry(null);
      setCountryStates([]);
    } else {
      setCountryStates([]);
    }
  };

  const renderCountry = () => {
    let options: any[] = [];
    options = [
      ...options,
      <option key="Select Country" value="0">
        Select Country
      </option>,
    ];

    countries.map(c => {
      options = [
        ...options,
        <option key={c.label} value={c.value}>
          {c.label}
        </option>,
      ];
    });
    return options;
  };

  const getCountry = (code: any) => {
    if (code && code !== '') {
      return ', ' + countries.filter(c => c.value == code)[0].label || '';
    }
    return '';
  };

  const changeAddress = event => {
    if (event.target.value == 'true') {
      setShowForm(true);
    } else {
      setShowForm(false);
    }
  };

  const handleClickBack = () => {
    if (back) back();
  };

  const handleClickSubmit = () => {
    firstNameBlurHandler(true);
    lastNameBlurHandler(true);
    emailBlurHandler(true);
    phoneNumberBlurHandler(true);
    address1BlurHandler(true);
    zipBlurHandler(true);
    cityBlurHandler(true);
    if (
      (enteredFirstNameIsValid &&
        enteredLastNameIsValid &&
        enteredEmailIsValid &&
        enteredPhoneNumberIsValid &&
        enteredAddress1IsValid &&
        enteredZipIsValid &&
        enteredCityIsValid) ||
      (data && showForm)
    ) {
      const temp = {
        firstName: firstName,
        lastName: lastName,
        email: email,
        company: company,
        countryCode: '1',
        stateCode: '0',
        phoneNumber: phoneNumber,
        faxNumber: faxNumber,
        address1: address1,
        address2: address2,
        city: city,
        zip: zip,
        paymentType: 'cash',
      };
      const step = address === 'billing' ? 1 : 2;

      if (data && showForm) {
        changeStep(step, data);
      } else {
        changeStep(step, temp);
      }
    }
  };

  return (
    <form action="">
      {data ? (
        <select
          id={`${address}-data`}
          name={`${address}-data`}
          className={`${address}-select`}
          onChange={e => {
            changeAddress(e);
          }}
          defaultValue={'true'}
        >
          <option value="false">New Address</option>
          <option value="true">
            {' '}
            {data.firstName +
              ', ' +
              data.lastName +
              ', ' +
              data.address1 +
              ', ' +
              data.city +
              ', ' +
              data.zip +
              getCountry(data.countryCode)}
          </option>
        </select>
      ) : (
        ''
      )}
      <div className={`checkout-data ${showForm ? 'hide' : ''}`}>
        <div className="form-input">
          <input
            id={`${address}-firstName`}
            className={`input form-text valid ${firstNameInputHasError ? 'invalid' : ''}`}
            placeholder="First name"
            type="text"
            onBlur={firstNameBlurHandler}
            onChange={firstNameChangedHandler}
            value={firstName}
          />
          <span className={`has-error${firstNameInputHasError ? ' show' : ''}`}>
            {firstNameError}
          </span>
        </div>
        <div className="form-input">
          <input
            id={`${address}-lastName`}
            className={`input form-text valid ${lastNameInputHasError ? 'invalid' : ''}`}
            placeholder="Last name"
            type="text"
            onBlur={lastNameBlurHandler}
            onChange={lastNameChangedHandler}
            value={lastName}
          />
          <span className={`has-error${lastNameInputHasError ? ' show' : ''}`}>
            {lastNameError}
          </span>
        </div>
        <div className="form-input">
          <input
            id={`${address}-email`}
            className={`input form-text valid ${emailInputHasError ? 'invalid' : ''}`}
            placeholder="Email"
            type="text"
            onBlur={emailBlurHandler}
            onChange={emailChangedHandler}
            value={email}
          />
          <span className={`has-error${emailInputHasError ? ' show' : ''}`}>{emailInputError}</span>
        </div>
        <div className="form-input">
          <input
            id={`${address}-company`}
            className={`input form-text valid`}
            placeholder="Company"
            type="text"
            onBlur={companyBlurHandler}
            onChange={companyChangedHandler}
            value={company}
          />
          {/* <span className={`has-error${companyInputHasError ? ' show' : ''}`}>
            {companyInputError}
          </span> */}
        </div>
        <div className="form-input">
          <input
            id={`${address}-phoneNumber`}
            className={`input form-text valid ${phoneNumberInputHasError ? 'invalid' : ''}`}
            placeholder="Phone number"
            type="text"
            onBlur={phoneNumberBlurHandler}
            onChange={phoneNumberChangedHandler}
            value={phoneNumber}
          />
          <span className={`has-error${phoneNumberInputHasError ? ' show' : ''}`}>
            {phoneNumberInputError}
          </span>
        </div>
        <div className="form-input">
          <input
            id={`${address}-faxNumber`}
            className={`input form-text valid`}
            placeholder="Fax number"
            type="text"
            onBlur={faxNumberBlurHandler}
            onChange={faxNumberChangedHandler}
            value={faxNumber}
          />
          {/* <span className={`has-error${faxNumberInputHasError ? ' show' : ''}`}>
            {faxNumberInputError}
          </span> */}
        </div>
        <div className="form-input">
          <input
            id={`${address}-address1`}
            className={`input form-text valid ${address1InputHasError ? 'invalid' : ''}`}
            placeholder="Address 1"
            type="text"
            onBlur={address1BlurHandler}
            onChange={address1ChangedHandler}
            value={address1}
          />
          <span className={`has-error${address1InputHasError ? ' show' : ''}`}>
            {address1InputError}
          </span>
        </div>
        <div className="form-input">
          <input
            id={`${address}-address2`}
            className="input form-text valid address"
            placeholder="Address 2"
            type="text"
            onBlur={address2BlurHandler}
            onChange={address2ChangedHandler}
            value={address2}
          />
        </div>
        <div className="form-input">
          <select
            id={`${address}-countryCode`}
            name={`${address}-countryCode`}
            className="input form-text select"
            onChange={e => {
              changeCountry(e);
            }}
          >
            {renderCountry()}
          </select>
        </div>
        <div className="form-input">
          <select
            id={`${address}-stateCode`}
            name={`${address}-stateCode`}
            className="input form-text select"
            defaultValue={'0'}
          >
            {country !== 1 && country !== null ? (
              <option key="Other (Non US)" value="0">
                Other (Non US)
              </option>
            ) : (
              <option key="Select States" value="0">
                Select States
              </option>
            )}
            {countryStates.map(s => (
              <option key={s.label} value={s.value}>
                {s.label}
              </option>
            ))}
          </select>
        </div>
        <div className="form-input">
          <input
            id={`${address}-city`}
            className={`input form-text valid ${cityInputHasError ? 'invalid' : ''}`}
            placeholder="City"
            type="text"
            onBlur={cityBlurHandler}
            onChange={cityChangedHandler}
            value={city}
          />
          <span className={`has-error${cityInputHasError ? ' show' : ''}`}>{cityInputError}</span>
        </div>
        <div className="form-input">
          <input
            id={`${address}-zip`}
            className={`input form-text valid ${zipInputHasError ? 'invalid' : ''}`}
            placeholder="Zip/postal code"
            type="text"
            onBlur={zipBlurHandler}
            onChange={zipChangedHandler}
            value={zip}
          />
          <span className={`has-error${zipInputHasError ? ' show' : ''}`}>{zipInputError}</span>
        </div>
      </div>
      <div className="cta-container">
        {address === 'shipping' ? <Button click={() => handleClickBack()}>Back</Button> : ''}
        <Button className="button submit-button" click={() => handleClickSubmit()}>
          Continue
        </Button>
      </div>
    </form>
  );
};

export default FormData;
